import { DOMAIN_VALUE, URL_REDIRECT } from '@/constants/domain';
import { UNACCEPTABLE_DOMAIN_STATUS } from '@/constants/status';
import router from '@/router';
import { getDNSList, getDomainDetail } from '@/services/domain.service';

export const DomainDetailModule = {
    state: {
        domainDetail: null,
        DNSRecords: [],
    },
    mutations: {
        setDetail(state, data) {
            state.domainDetail = data;
        },
        clearDetail(state) {
            state.domainDetail = null;
        },
        setDNSRecords(state, data) {
            state.DNSRecords = data;
        },
    },
    actions: {
        async fetchDomainDetail({ commit }) {
            try {
                const id = router.currentRoute.params.id;
                this.commit('loading/setLoading', true);
                const { data: domain } = await getDomainDetail(id);
                this.commit('loading/setLoading', false);
                if (UNACCEPTABLE_DOMAIN_STATUS.includes(domain.status)) {
                    router
                        .push({
                            name: 'domain.list',
                        })
                        .catch(() => {});
                    return;
                }
                commit('setDetail', domain);
            } catch (e) {
                this.commit('loading/setLoading', false);
                router
                    .push({
                        name: 'domain.list',
                    })
                    .catch(() => {});
            }
        },
        async fetchDNSRecords({ commit, state }) {
            const id = state.domainDetail?.id;
            if (id) {
                try {
                    this.commit('loading/setLoading', true);
                    const { data } = await getDNSList(id);
                    this.commit('loading/setLoading', false);
                    commit('setDNSRecords', data.dns);
                } catch (e) {
                    this.commit('loading/setLoading', false);
                }
            }
        },
    },
    getters: {
        redirectDomains(state) {
            return state.DNSRecords.filter(
                (i) => i.recordType === URL_REDIRECT.URL
            ).map((i) => {
                return {
                    ...i,
                    hostName:
                        i.hostName === DOMAIN_VALUE
                            ? state.domainDetail.sld +
                              '.' +
                              state.domainDetail.tld
                            : i.hostName,
                    edit: false,
                    errors: {
                        hostName: '',
                        address: '',
                    },
                };
            });
        },
    },
    namespaced: true,
};
